export default __webpack_public_path__ + "static/media/logo.4a53147b.svg";